import React, { useRef } from 'react';
import {
  Image, StyleSheet, Text, TouchableOpacity, View,
} from 'react-native';
import { useHover } from 'react-native-web-hooks';
import { LocStr } from '../utils/Utils';
import {
  img_duplication_add,
  img_duplication_delete,
} from '../utils/ImagesManagementUtils';
import Details from './PanelsComponents/Text/Details';
import { getRepresentativeKey } from '../utils/DictionaryManagementUtils';

//= ========================================================================

const MySquareButton = ({
  service,
  onServiceStateChanged,
  value,
  nowDragging,
  title,
  language,
  onDuplicateFlowService,
  onDeleteDuplicatedFlowService,
  showDeleteButton,
}) => {
  const theRefDeleteButton = useRef(null);
  const theRefAddButton = useRef(null);
  const theRefSelected = useRef(null);

  const isHoveredDeleteButton = useHover(theRefDeleteButton);
  const isHoveredAddButton = useHover(theRefAddButton);
  const isHoveredSelected = useHover(theRefSelected);

  return (
    <TouchableOpacity
      style={value ? styles.btnSelected : styles.btnUnselected}
      disabled={nowDragging}
      onPress={() => {
        onServiceStateChanged(!value);
      }}
      ref={theRefSelected}
    >
      <View style={styles.whiteBk}>
        <Text style={styles.lblText}>{LocStr(title, language)}</Text>
        <Details>{getRepresentativeKey(service)}</Details>
      </View>
      {isHoveredSelected && value ? (
        <View style={styles.iconsBk}>
          {showDeleteButton ? (
            <TouchableOpacity
              style={isHoveredDeleteButton ? styles.iconBk : styles.iconBkHover}
              ref={theRefDeleteButton}
            >
              <Image
                fadeDuration={0}
                style={styles.btnDuplicateFlow}
                source={img_duplication_delete}
                onClick={() => onDeleteDuplicatedFlowService()}
              />
            </TouchableOpacity>
          ) : null}
          <TouchableOpacity
            style={isHoveredAddButton ? styles.iconBk : styles.iconBkHover}
            ref={theRefAddButton}
          >
            <Image
              fadeDuration={0}
              style={styles.btnDuplicateFlow}
              source={img_duplication_add}
              onClick={() => onDuplicateFlowService()}
            />
          </TouchableOpacity>
        </View>
      ) : null}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  btnSelected: {
    width: 142,
    height: 102,
    borderRadius: 12,
    shadowColor: 'rgba(0,109,199,0.12)',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.12,
    shadowRadius: 12,
    // position: 'absolute',
    backgroundColor: '#008cff',
  },
  btnUnselected: {
    width: 142,
    height: 102,
    borderRadius: 12,
    shadowColor: 'rgba(0,109,199,0.12)',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.12,
    shadowRadius: 12,
    backgroundColor: '#edf2f7',
  },
  whiteBk: {
    width: 138,
    height: 98,
    margin: 2,
    padding: 10,
    borderRadius: 10,
    position: 'absolute',
    backgroundColor: '#fff',
  },
  lblText: {
    width: 102,
    maxHeight: 92,
    fontWeight: 500,
    fontFamily: 'Rubik-Medium',
    fontSize: 16,
    color: '#001a2f',
    wordWrap: 'break-word',
    whiteSpace: 'pre-line',
  },
  btnDuplicateFlow: {
    width: 24,
    height: 24,
  },
  iconsBk: {
    bottom: 13,
    right: 13,
    position: 'absolute',
    flexDirection: 'row',
  },
  iconBk: {
    width: 28,
    height: 28,
    padding: 2,
    marginLeft: 10,
    borderRadius: 6,
    backgroundColor: '#d9eeff',
    shadowColor: 'rgba(0,109,199,0.12)',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.12,
    shadowRadius: 12,
  },
  iconBkHover: {
    width: 28,
    height: 28,
    padding: 2,
    marginLeft: 10,
    borderRadius: 6,
    backgroundColor: '#ffffff',
    shadowColor: 'rgba(0,109,199,0.12)',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.92,
    shadowRadius: 12,
  },
});

export default MySquareButton;
